import './TutorialModalStyles.scss';

import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import HandImage from '../../../../assets/img/components/Questions/TutorialModal/hand-white.png';
import NextQuestionButtonImage from '../../../../assets/img/components/Questions/TutorialModal/next-question-button.png';
import PreviousQuestionButtonImage from '../../../../assets/img/components/Questions/TutorialModal/previous-question-button-transp.png';

function TutorialModal({ isOpen, toggle, setTutorialModalDone }) {
  const [showNextQuestion, setShowNextQuestion] = useState(true);

  useEffect(() => {
    const toggleTimeout = setTimeout(() => {
      setShowNextQuestion(!showNextQuestion);
    }, 10000);

    return () => {
      clearTimeout(toggleTimeout);
    };
  }, [showNextQuestion]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      backdrop
      centered
      className="modal"
    >
      <ModalBody className="modal__body">
        <img src={HandImage} alt="Hand" className="modal__body__hand-icon" />
        <img
          src={
            showNextQuestion
              ? NextQuestionButtonImage
              : PreviousQuestionButtonImage
          }
          alt="Next question button"
          className={
            showNextQuestion
              ? 'modal__body__next-question-icon'
              : 'modal__body__previous-question-icon'
          }
        />
        <p className="modal__body__description">
          {showNextQuestion
            ? 'After you answer a question, you can either select the Easy, Medium or Hard to rate the question, OR click the Next Question button to move on to the next question (assigns a "Medium" difficulty to the question")'
            : 'Before answering, you can use the Previous Question button to go back to the previous question.'}
        </p>
        <button
          className="modal__body__button"
          data-test="tutorial-modal-continue-button"
          onClick={() => {
            toggle();
            setTutorialModalDone();
          }}
        >
          CONTINUE
        </button>
      </ModalBody>
    </Modal>
  );
}

export default TutorialModal;
